<template>
  <div class="showTemplate">
    <div class="filterCondition" style="padding: 0px 5px; margin-bottom: 20px">
      <a-space>
        <a-button type="primary" @click="releshAll" :loading="releshBtn">
          刷新计划
        </a-button>

        <a-radio-group
          default-value="a"
          v-model="smart_bid_type"
          button-style="solid"
          @change="handletargetChange"
        >
          <a-radio-button value="SMART_BID_CONSERVATIVE">
            放量投放（起量快）
          </a-radio-button>
          <a-radio-button value="SMART_BID_CUSTOM"> 控成本投放 </a-radio-button>
        </a-radio-group>

        <a-input-search
          v-model="order_id"
          :allowClear="true"
          style="width: 250px; margin-left: 0px"
          placeholder="计划ID/名称/商品ID/名称"
          enter-button
          @search="onSearchKey"
        />

        <a-select
          v-model="status"
          style="width: 140px"
          @change="handleChange"
          placeholder="全部计划状态"
        >
          <a-select-option
            v-for="(item, index) in statusData"
            :key="index"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-space>
    </div>
    <a-spin :spinning="spinning" tip="加载中...">
      <div class="scroll-tabox">
        <a-table
          ref="inOrderTable"
          :columns="columns"
          :data-source="data"
          :pagination="pagination"
          :sortDirections="['descend', 'ascend', '']"
          @change="handleTableChange"
          :rowKey="(record) => record.ad_info.id"
          :rowSelection="{
            selectedRowKeys,
            onChange: onSelectChange,
          }"
          :scroll="{ x: 2000 }"
        >
          <div slot="ad" class="aweme-right" slot-scope="text">
            <div>
              <a-tooltip placement="top" :title="text.ad_info.name">
                <div class="aweme-title" @click="getDetail(text)">
                  {{ text.ad_info.name }}
                </div>
              </a-tooltip>
            </div>
            <div style="display: flex">
              <div style="margin-left: 5px">
                <div class="small">创建时间:{{ text.ad_info.create_time }}</div>
                <div class="small">
                  ID:{{ text.ad_info.id }}
                  <a-icon type="copy" @click="text_copy(text.ad_info.id)" />
                </div>
              </div>
            </div>
          </div>
          <div
            class="delivery_setting"
            slot="delivery_setting"
            slot-scope="text"
          >
            <div v-if="text.ad_info.budget">
              预算:{{ text.ad_info.budget }}元
              <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_DAY'"
                >/日</span
              >
              <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_TOTAL'"
                >/总</span
              >
            </div>
            <div v-if="text.ad_info.roi2_goal">
              ROI目标:{{ text.ad_info.roi2_goal }}
            </div>
            <div>
              <a-progress
                :percent="
                  parseInt(
                    (text.stats_info.stat_cost / text.ad_info.budget) * 100
                  )
                "
                size="small"
                status="active"
                v-if="
                  parseInt(
                    (text.stats_info.stat_cost / text.ad_info.budget) * 100
                  ) < 70
                "
              />
              <a-progress
                strokeColor="#f5222d"
                :percent="
                  parseInt(
                    (text.stats_info.stat_cost / text.ad_info.budget) * 100
                  )
                "
                size="small"
                status="active"
                v-else-if="
                  parseInt(
                    (text.stats_info.stat_cost / text.ad_info.budget) * 100
                  ) < 100 &&
                  parseInt(
                    (text.stats_info.stat_cost / text.ad_info.budget) * 100
                  ) >= 70
                "
              />
              <a-progress
                :percent="
                  parseInt(
                    (text.stats_info.stat_cost / text.ad_info.budget) * 100
                  )
                "
                size="small"
                v-else
              />
            </div>
          </div>

          <div class="aweme" slot="aweme" slot-scope="text">
            <div class="aweme-left">
              <img
                class="videoimg"
                :src="text.room_info[0].anchor_avatar"
                v-if="text.room_info[0].anchor_avatar"
              />
            </div>
            <div class="aweme-right">
              <a-tooltip
                placement="top"
                :title="text.room_info[0].anchor_name"
                style="height: auto"
              >
                <div class="aweme-title" @click="getDetail(text)">
                  {{ text.room_info[0].anchor_name }}
                </div>
              </a-tooltip>
              <div class="product_img_box">
                <div v-for="(it, i) in text.product_info" :key="i">
                  <img
                    :src="it.product_image"
                    class="product_img"
                    @click="goDetail(it.product_id)"
                  />
                </div>
                <span class="product_name small"
                  >共{{ text.product_info.length }}件商品</span
                >
              </div>
              <div class="aweme-id small">
                ID：{{ text.room_info[0].anchor_id }}
                <a-icon
                  type="copy"
                  @click="text_copy(text.room_info[0].anchor_id)"
                />
              </div>
              <div class="small">
                {{
                  text.ad_info.smart_bid_type == 'SMART_BID_CUSTOM'
                    ? '控成本投放'
                    : '放量投放'
                }}
              </div>
            </div>
          </div>

          <template slot="zt" slot-scope="text">
            <div v-if="text.ad_info.status == 'DELIVERY_OK'">
              <a-tag color="green"> 投放中 </a-tag>
            </div>
            <div v-else>
              <a-tag color="red">
                {{ getStatusName(text.ad_info.status) }}
              </a-tag>
            </div>
          </template>

          <div
            class="green-roi"
            slot="total_prepay_and_pay_order_roi2"
            slot-scope="text"
          >
            <b
              v-if="text.stats_info.total_prepay_and_pay_order_roi2 > 0"
              style="color: green"
              >{{ text.stats_info.total_prepay_and_pay_order_roi2 }}</b
            >
            <b v-else style="color: red">0</b>
          </div>

          <div slot="stat_cost" slot-scope="text">
            {{ text.stats_info.stat_cost }}
          </div>

          <div slot="total_pay_order_gmv_for_roi2" slot-scope="text">
            {{ text.stats_info.total_pay_order_gmv_for_roi2 }}
          </div>

          <div slot="total_pay_order_count_for_roi2" slot-scope="text">
            {{ text.stats_info.total_pay_order_count_for_roi2 }}
          </div>

          <div slot="total_cost_per_pay_order_for_roi2" slot-scope="text">
            {{ text.stats_info.total_cost_per_pay_order_for_roi2 }}
          </div>

          <div slot="total_pay_order_coupon_amount_for_roi2" slot-scope="text">
            {{ text.stats_info.total_pay_order_coupon_amount_for_roi2 }}
          </div>

          <div
            slot="total_unfinished_estimate_order_gmv_for_roi2"
            slot-scope="text"
          >
            {{ text.stats_info.total_unfinished_estimate_order_gmv_for_roi2 }}
          </div>
        </a-table>
      </div>
    </a-spin>

    <div :style="{}" class="drawerFooter">
      <a-button :style="{ marginRight: '8px' }" @click="onClose">
        取消
      </a-button>
      <a-button
        type="primary"
        @click="onOk"
        :disabled="selectedRowKeys.length == 0"
      >
        确定
      </a-button>
    </div>
  </div>
</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import moment from 'moment';
const columns = [
  {
    title: '计划信息',
    key: 'ad',
    width: 250,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'ad' },
    fixed: 'left',
  },
  {
    title: '投放信息',
    key: 'aweme',
    width: 300,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'aweme' },
    // fixed: 'left',
  },
  {
    title: '计划状态',
    key: 'zt',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'zt' },
  },
  {
    title: '预算/出价',
    key: 'delivery_setting',
    align: 'center',
    width: 150,
    scopedSlots: { customRender: 'delivery_setting' },
  },
  {
    title: '消耗（元）',
    key: 'stat_cost',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'stat_cost' },
  },
  {
    title: '整体支付ROI',
    key: 'total_prepay_and_pay_order_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_prepay_and_pay_order_roi2' },
  },
  {
    title: '整体成交金额',
    key: 'total_pay_order_gmv_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_pay_order_gmv_for_roi2' },
  },
  {
    title: '整体成交订单数',
    key: 'total_pay_order_count_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_pay_order_count_for_roi2' },
  },
  {
    title: '整体成交订单成本',
    key: 'total_cost_per_pay_order_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_cost_per_pay_order_for_roi2' },
  },
  {
    title: '整体成交智能优惠券金额',
    key: 'total_pay_order_coupon_amount_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: { customRender: 'total_pay_order_coupon_amount_for_roi2' },
  },
  {
    title: '整体未完结预售订单预估金额',
    key: 'total_unfinished_estimate_order_gmv_for_roi2',
    align: 'center',
    sorter: true,
    scopedSlots: {
      customRender: 'total_unfinished_estimate_order_gmv_for_roi2',
    },
  },
];
const data = [];
const key = 'updatable';
export default {
  name: 'ShowTemplate',
  props: {
    advertiser_id: {
      type: String,
      default: '',
    },
    marketing_goal: {
      type: String,
      default: '',
    },
    video_info_aweme_item_id: {
      type: String,
      default: '',
    },
    campaign_scene: {
      type: String,
      default: '',
    },
    aweme_info_aweme_id: {
      type: String,
      default: '',
    },
    selectKeys: {
      type: Array,
    },
  },

  data() {
    return {
      spinning: false,
      columns,
      data,
      status: '', // 分页参数
      report: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      page: 1,
      pagesize: 10,
      selectedRow: [],
      selectedRowKeys: [],
      statusData: [
        { name: '全部计划状态', value: '' },
        { name: '新建审核中', value: 'AUDIT' },
        { name: '已删除', value: 'DELETE' },
        { name: '投放中', value: 'DELIVERY_OK' },
        { name: '已暂停', value: 'DISABLE' },
        { name: '草稿', value: 'DRAFT' },
        { name: '数据错误', value: 'ERROR' },
        { name: '落地页暂不可用', value: 'EXTERNAL_URL_DISABLE' },
        { name: '已终止', value: 'FROZEN' },
        { name: '关联直播间未开播', value: 'LIVE_ROOM_OFF' },
        { name: '不在投放时段', value: 'NO_SCHEDULE' },
        { name: '审核不通过', value: 'OFFLINE_AUDIT' },
        { name: '账户余额不足', value: 'OFFLINE_BALANCE' },
        { name: '广告超出预算', value: 'OFFLINE_BUDGET' },
        { name: '预上线', value: 'PRE_ONLINE' },
        { name: 'QUOTA配额不足暂停计划', value: 'QUOTA_DISABLE' },
        { name: '修改审核中', value: 'REAUDIT' },
        { name: '全域推广暂停', value: 'ROI2_DISABLE' },
        { name: '系统暂停', value: 'SYSTEM_DISABLE' },
        { name: '已完成', value: 'TIME_DONE' },
        { name: '未到达投放时间', value: 'TIME_NO_REACH' },
        { name: '账户超出预算', value: 'ADVERTISER_OFFLINE_BUDGET' },
        { name: '账户接近预算', value: 'ADVERTISER_PRE_OFFLINE_BUDGET' },
        { name: '异常，请联系审核人员', value: 'AUDIT_STATUS_ERROR' },
        { name: '关联抖音号不可投', value: 'AWEME_ACCOUNT_DISABLED' },
        { name: '已被广告组暂停', value: 'CAMPAIGN_DISABLE' },
        { name: '广告组超出预算', value: 'CAMPAIGN_OFFLINE_BUDGET' },
        { name: '广告组接近预算', value: 'CAMPAIGN_PRE_OFFLINE_BUDGET' },
      ],
      smart_bid_type: 'SMART_BID_CUSTOM',
      ad: {},
      dataMap: {},
      deadline: Date.now() + 1000 * 31,
      deadtitle: '定时刷新中：倒计时',
      sortby: 'ad_id',
      sort: 'descend',
      order_id: '',
      timeType: 'ALL',
      range_date: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      timeday: '0',
      toploading: false,
      topkey: 1,
      switchloading: false,
      timer_status: true,
      releshBtn: false,
      xData: [],
      y1: [],
      y2: [],
      y3: [],
      y4: [],
      y5: [],
      y6: [],
      new_budget: '',
      new_bid: '',
      new_roi: '',
      tableKey: '1',
      totalItem: {
        stat_cost: '-',
        pay_order_amount: '-',
        prepay_and_pay_order_roi: '-',
        pay_order_count: '-',
      },
      logDrawer: false,
      log_data: [],
    };
  },

  components: {},

  watch: {
    advertiser_id(a, b) {
      this.page = 1;
      this.pagination.current = 1;
      this.order_id = '';
      this.getData();
      this.selectedRowKeys = [];
    },
  },
  async mounted() {
    this.getData();
    console.log('saaaa', this.selectKeys);
    this.selectedRowKeys = this.selectKeys;
  },
  methods: {
    moment,
    onOk() {
      console.log('_______', this.selectedRowKeys);
      this.$emit('selectAdDrawer', this.selectedRowKeys);
    },
    onClose() {
      this.$emit('closeAdDrawer');
    },
    clearSelect() {
      this.selectedRowKeys = [];
      this.getData();
    },
    getStatusName(status) {
      const statusItem = this.statusData.find((item) => item.value === status);
      return statusItem ? statusItem.name : status;
    },
    async releshAll() {
      this.releshBtn = true;
      this.getData();
      this.releshBtn = false;
    },
    get_campaign_scene(campaign_scene) {
      let text = '';
      switch (campaign_scene) {
        case 'DAILY_SALE':
          text = '日常销售';
          break;
        case 'NEW_CUSTOMER_TRANSFORMATION':
          text = '新客转化';
          break;
        case 'LIVE_HEAT':
          text = '直播间加热';
          break;
        case 'PLANT_GRASS':
          text = '人群种草';
          break;
        case 'PRODUCT_HEAT':
          text = '商品加热';
          break;
        default:
          break;
      }
      return text;
    },
    get_marketing_scene(tag) {
      let text = '';
      switch (tag) {
        case 'FEED':
          text = '通投广告';
          break;
        case 'SEARCH':
          text = '搜索广告';
          break;
        case 'SHOPPING_MALL':
          text = '商城广告';
          break;
        default:
          break;
      }
      return text;
    },
    get_lab_ad_type(tag) {
      let text = '';
      switch (tag) {
        case 'NOT_LAB_AD':
          text = '自定义';
          break;
        case 'LAB_AD':
          text = '托管';
          break;
        default:
          break;
      }
      return text;
    },
    async onSwitchChange(e) {
      console.log(e);
      this.switchloading = true;
      let opt_status = e.opt_status == 'ENABLE' ? 'DISABLE' : 'ENABLE';
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.STOP_QC_AD}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: e.ad_id,
          opt_status: opt_status,
        },
      });
      this.switchloading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      e.opt_status = opt_status;
    },
    // 复制操作
    text_copy(context) {
      navigator.clipboard
        .writeText(context)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch((err) => {
          this.$message.error('复制失败');
        });
    },
    onSearchKey(e) {
      console.log('输入的ID', e);
      this.order_id = e;
      this.page = 1;
      this.data = [];
      this.getData();
    },
    govideo(e) {
      const strUrl =
        'https://www.douyin.com/video/' + e.video_info_aweme_item_id;
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.target = '_blank';
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    },
    copyOneAd(e) {
      this.ad = e;
      this.$refs.copy.showVisible(e);
    },
    getDetail(e) {
      this.ad = e;
      this.$refs.detail.getAdDetail(e);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRow = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(
        'selectedRowKeys changed: ',
        this.selectedRow,
        this.selectedRowKeys
      );
    },
    handleTableChange(e, filters, sorter) {
      console.log('点击了', sorter);
      if (sorter.order) {
        this.sort = sorter.order;
        this.sortby = sorter.field;
      } else {
        this.sort = 'descend';
        this.sortby = 'ad_id';
      }
      this.pagination = e;
      this.page = e.current;
      this.pagesize = e.pageSize;
      this.getData();
    },
    async handleChange(e) {
      console.log('获取到的状态', e);
      this.status = e;
      this.getData();
    },
    handletargetChange(e) {
      this.delivery_setting_external_action = e;
      this.getData();
    },
    async getData() {
      this.spinning = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_AD_LIST}`,
        method: 'POST',
        params: {
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          advertiser_id: this.advertiser_id,
          status: this.status,
          marketing_goal: this.marketing_goal,
          search_keyword: this.order_id,
          sortby: this.sortby,
          sort: this.sort,
          page: this.page,
          pagesize: this.pagesize,
          smart_bid_type: this.smart_bid_type,
          adlab_scene:'OVERALL_PROJECT'
        },
      });
      this.spinning = false;
      if (code == 0) {
        return;
      }
      if (!data) return;
      this.data = data.ad_list;
      this.pagination.total = data.page_info.total_num;
    },
  },
};
</script>

<style lang="less" scoped>
.extra-wrapper {
  position: absolute;
  right: 0px;
}

.ant-card-head-wrapper {
  text-align: left !important;
  font-weight: bold !important;
  color: #000;
}

.widget-1 {
  display: flex;

  .ant-statistic-content {
    font-family: open sans, Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: inherit;
    font-size: 30px;
    line-height: 30px;
    text-align: center;
    margin: 10px auto;
  }

  .icon {
    width: 48px;
    height: 48px;
    position: absolute;
    right: 16px;
    margin: auto;
    background-color: #1890ff;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.12);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.ant-tabs-tab {
  font-weight: bold !important;
}

.extra-item {
  display: inline-block;
  margin-right: 24px;

  a {
    margin-left: 24px;
    color: #666;
    font-weight: bold;
  }

  .selected {
    color: #1890ff;
  }
}

.searchResult {
  .name {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }
}

.aweme {
  display: flex;
}

.aweme-right {
  text-align: left;

  .aweme-title {
    color: #323335;
    font-weight: bold;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 180px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    height: 45px;
  }
}

.small {
  font-size: 11px;
  line-height: 18px;
}

.tips {
  margin-bottom: 10px;
}

.showTemplate {
  .dataOverview {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0;
  }

  .dataViewItem {
    flex: 1;
    margin-right: 0.5%;
    margin-left: 0.5%;
    border-radius: 15px;
    float: left;
    box-shadow: 0 2px 8px #00000026;
    margin-bottom: 10px;
    overflow: hidden;
    height: 120px;

    div {
      text-align: left;
      color: #333;
      font-size: 18px;
      padding-top: 20px;
      padding-left: 20px;
    }

    p {
      font-size: 24px;
      padding-top: 5px;
      font-weight: bold;
    }
  }
}

.copy-icon {
  height: 100px;
  border-radius: 5px;
  cursor: pointer;
}

.rowOperate {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 30px;

  .actionItem {
    margin-left: 10px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.filterCondition {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  span {
    margin-left: 20px;
  }
}

.tags-container {
  padding: 16px 0px;
  overflow: hidden;
}

.tags-container .ad-tag {
  float: left;
  margin-left: 16px;
}

.tags-container .ad-tag:first-child {
  margin-left: 0;
}

.tags-container .inbl {
  display: inline-block;
  vertical-align: middle;
}

.tags-container .roi-input {
  position: relative;
  top: 1px;
}

.tags-container .roi-target-box {
  display: inline-block;
  margin-left: 24px;
}

.tags-container .info-item {
  float: left;
  height: 26px;
  position: relative;
}

.avatar {
  widows: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 5px;
}

.tags-container .info-item.editable {
  padding-right: 28px;
}

.tags-container .info-item .content {
  display: inline-block;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-container .info-item .content .nobid-bid-content {
  color: #999;
}

.tag {
  background: #f2f2f2;
  border-radius: 4px;
  color: #999;
  font-size: 14px;
  line-height: 22px;
  padding: 2px 8px;
}

.tag.red {
  background: #fff1ef;
  color: #e5453f;
}

.tag.gray {
  background: #f2f2f2;
  color: #999;
}

.tag.green {
  background: #e6f8ee;
  color: #34ba7b;
}

.copynum {
  font-weight: bold;
  color: red;
}

.product-item {
  display: flex;
  height: 56px;
  margin-top: 8px;
}

.product-item .good {
  padding-left: 0;
}

.product-item .icon {
  border-radius: 4px;
  height: 56px;
  width: 56px;
}

.product-item .info {
  padding-top: 3px;
}

.product-item .info .name {
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 0 0 8px 16px;
}

.product-item .info .id,
.product-item .info .price {
  color: #999;
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  padding: 0 16px;
}

.product-item .info .separator {
  border-right: 1px solid #999;
  display: inline-block;
  height: 8px;
  position: relative;
}

.product-item .info .price-num {
  color: #333;
  margin-left: 8px;
}

.ad-drawer__aweme-info {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 16px;
}

.title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 34px;
}

.board-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 21px;
  min-width: 932px;

  .overview-board {
    background: #f2f2f2;
    background-color: #f2f2f2;
    margin: 0 10px 10px 0;
    border-radius: 8px;
    cursor: pointer;
    height: 108px;
    width: 175px;

    .inner {
      border-radius: 4px;
      padding: 12px 12px 17px;

      .metric {
        color: #252729;
        font-size: 14px;
        font-weight: 600;
        height: 20px;
        line-height: 20px;
        margin: 0;
      }

      .value {
        font-size: 20px;
        margin-top: 8px;
        font-weight: bold;
        color: rgb(51, 51, 51);
      }
    }
  }
}

.setting-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  min-height: 44px;
  padding: 12px 16px;
  width: 50%;
  float: left;

  label {
    color: #333;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 24px;
    width: 80px;
  }

  .display-value {
    color: #333;
    flex: 1 1;
  }
}

.footer {
  position: fixed;
  bottom: 0px;
  background: #fff;
  height: 80px;
  width: 940px;
  line-height: 80px;
  border-top: 1px solid #eee;

  button {
    margin-right: 10px;
  }
}

.videoimg {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
}

.dialog-left {
  width: 180px;
  float: left;
  padding-top: 20px;
  height: 100%;
  border-right: 1px solid #e5e5e5;
}

.dialog-left ul li {
  margin: 0 auto;
  line-height: 40px;
  font-size: 16px;
  color: #2d3035;
  width: 130px;
  height: 40px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  cursor: pointer;
}

.dialog-center {
  width: 620px;
  float: left;
  padding: 10px 20px;
  color: #242a37;

  ul {
    padding: 0;
    margin: 0;
  }
}

.dialog-right {
  width: 190px;
  float: left;
  padding: 10px;
  color: #939cc0;
  height: 340px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
  scrollbar-width: thin;
  border-left: 1px solid #e5e5e5;
}

.dialog-center-title {
  font-size: 16px;
  margin-bottom: 10px;
}

li {
  list-style: none;
}

.dialog-right ul li {
  margin: 0 auto;
  line-height: 30px;
  font-size: 14px;
  color: #13151a;
  width: 184;
  height: 30px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 10px;
  cursor: pointer;
  background: #f2f2f2;
  position: relative;
}

.dialog-right ul li span {
  float: right;
  margin-right: 10px;
}

.dialog-center ul li {
  width: 25%;
  margin-bottom: 10px;
  float: left;
}

.dialog-right ul {
  margin: 0;
  padding: 0;
}

.yAxis {
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    width: 145px;
    border-radius: 5px;
  }

  & > div {
    display: flex;
    align-items: center;
  }

  section {
    width: 13px;
    height: 12px;
    background: #ff4d4f;
    border-radius: 3px;
    margin-right: 10px;
  }

  & > div:nth-child(1) {
    margin-right: 35px;

    section {
      background-color: #1890ff;
    }
  }
}

.yAxis + .totops {
  height: 0;
  opacity: 0;
}

/* 在你的CSS文件或<style>标签中添加以下样式 */
/deep/ .ant-table-tbody > tr > td {
  padding: 8px;
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px;
}

// css

.ant-card {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03),
    0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  border-top: 1px solid #efefef;
}

.acss-14lc1cu {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.acss-1fpsglh {
  margin-top: 8px;
  padding-top: 9px;
  border-top: 1px solid rgba(5, 5, 5, 0.06);
}

.acss-grxbm {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

.acss-eji7bv {
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.acss-1x0bxe0 {
  font-size: 14px;
  line-height: 22px;
}

.acss-72p16p {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.88);
}

.acss-qdes8r {
  position: relative;
  top: 4px;
  float: left;
  margin-right: 20px;
}

.acss-1odwksc {
  float: left;
}

.acss-1qoci3j {
  height: 22px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.acss-18kfphl {
  position: absolute;
  top: 4px;
  right: 0;
  line-height: 1;
  cursor: pointer;
}

.acss-f1zikh {
  height: 38px;
  margin-top: 4px;
  margin-bottom: 0;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.88);
  font-size: 30px;
  line-height: 38px;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}

.acss-16mkun2 {
  margin-top: 10px;
}

.totalItem {
  text-align: left;

  b {
    margin-right: 30px;
  }
}

/deep/ .ant-checkbox + span {
  padding-left: 2px;
}
.product_img_box {
  display: flex;
}
.product_img {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  margin-right: 5px;
  cursor: pointer;
}
</style>
